import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-player-schedule',
    templateUrl: './player-schedule.component.html',
    styleUrls: ['./player-schedule.component.css']
})
export class PlayerScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
